// C2 · Country (sections/c2-country.liquid). Places the "FR · EUR" link without editing the theme's header:
// - header: at the start of the right-hand icons (desktop and / or mobile, per the section settings);
// - mobile menu drawer: at the top of its footer;
// - C2 · Footer: right after "© year BigStuffed" in the bottom bar.
// The panel is moved to the end of <body> (out of the header's stacking context) and opened / closed here;
// picking a country submits Shopify's localization form (plain form submit, no script needed for that).
(() => {
  const norm = (t) => (t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

  const place = () => {
    const src = document.querySelector('[data-c2co]');
    if (!src || src.dataset.placed) return;
    src.dataset.placed = '1';
    const link = src.querySelector('[data-c2co-open]');
    const panel = src.querySelector('[data-c2co-panel]');
    const scrim = src.querySelector('.c2co__scrim');
    if (!link || !panel) return;
    document.body.append(scrim, panel);

    const desktop = src.dataset.desktop === 'true';
    const mobileHeader = src.dataset.mobileHeader === 'true';
    const links = [];

    const buttons = document.querySelector('.header__icons--right .header__buttons');
    if (buttons && (desktop || mobileHeader)) {
      const l = link.cloneNode(true);
      l.classList.add('c2co__link--header');
      if (!desktop) l.classList.add('c2co__link--mobile-only');
      if (!mobileHeader) l.classList.add('c2co__link--desktop-only');
      const cta = buttons.querySelector('.header__cta-button');
      buttons.insertBefore(l, cta ? cta.nextSibling : buttons.firstChild);
      links.push(l);
    }
    const copy = document.querySelector('.c2f__copy');
    if (copy && src.dataset.footer === 'true') {
      const l = link.cloneNode(true);
      l.classList.add('c2co__link--footer');
      copy.after(l);
      links.push(l);
    }
    const footer = document.querySelector('#menu-drawer-dialog .menu-drawer__footer');
    if (footer && src.dataset.drawer === 'true') {
      const l = link.cloneNode(true);
      l.classList.add('c2co__link--drawer');
      footer.prepend(l);
      links.push(l);
    }

    let opener = null;
    const open = (from) => {
      opener = from;
      // the country list arrives in a <template> (speed): written in on first opening
      const tpl = panel.querySelector('template[data-c2co-fill]');
      if (tpl) tpl.replaceWith(tpl.content);
      // close the theme's menu drawer first if the link was in it
      const drawer = from.closest('dialog');
      if (drawer && drawer.open) drawer.close();
      scrim.hidden = false;
      panel.hidden = false;
      document.documentElement.classList.add('c2co-lock');
      const current = panel.querySelector('[aria-current="true"]');
      if (current) current.scrollIntoView({ block: 'center' });
      (panel.querySelector('[data-c2co-search]') || current || panel.querySelector('[data-c2co-row]')).focus({ preventScroll: true });
    };
    const close = () => {
      scrim.hidden = true;
      panel.hidden = true;
      document.documentElement.classList.remove('c2co-lock');
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    };
    links.forEach((l) => l.addEventListener('click', () => open(l)));
    scrim.addEventListener('click', close);
    panel.querySelectorAll('[data-c2co-close]').forEach((b) => b.addEventListener('click', close));
    panel.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      const f = [...panel.querySelectorAll('button, input')].filter((x) => !x.hidden && x.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });

    const search = panel.querySelector('[data-c2co-search]');
    if (search) {
      const rows = () => [...panel.querySelectorAll('[data-c2co-row]')];
      search.addEventListener('input', () => {
        const empty = panel.querySelector('[data-c2co-empty]');
        const q = norm(search.value);
        let shown = 0;
        rows().forEach((r) => { const on = !q || norm(r.dataset.name).includes(q) || norm(r.value) === q; r.hidden = !on; if (on) shown += 1; });
        if (empty) empty.hidden = shown > 0;
      });
      // Enter in the search field picks the first country left in the list
      search.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        const first = rows().find((r) => !r.hidden);
        if (first) first.click();
      });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
  // theme editor: after an edit of this section, remove what was placed before and place it again
  document.addEventListener('shopify:section:load', (e) => {
    if (!e.target.querySelector('[data-c2co]')) return;
    document.querySelectorAll('.c2co__link--header, .c2co__link--drawer, .c2co__link--footer').forEach((l) => l.remove());
    document.querySelectorAll('body > .c2co, body > .c2co__scrim').forEach((p) => p.remove());
    document.documentElement.classList.remove('c2co-lock');
    place();
  });
  document.addEventListener('shopify:section:unload', (e) => {
    if (!e.target.querySelector('[data-c2co]')) return;
    document.querySelectorAll('.c2co__link--header, .c2co__link--drawer, .c2co__link--footer, body > .c2co, body > .c2co__scrim').forEach((l) => l.remove());
    document.documentElement.classList.remove('c2co-lock');
  });
})();
